export enum CatalogViewTreeItemType {
	Unknown = 0,
	Folder = 1,
	FolderWithAttachments = 2,
	TextOrDocument = 3,
	TextOrDocumentWithAttachments = 4,
	Position = 5,
	PositionWithAttachments = 6,
	CustomItem = 7
}